import { CustomRegistry } from '@nemuru-eng/js-api-client';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const CustomRegistryOptions = (t: GetTextIdTranslationType) =>
  Object.values(CustomRegistry).map((value) => ({
    value,
    display: t(value.toLowerCase()) || value.toLowerCase(),
  }));
